import { render, staticRenderFns } from "./OrderDetailAdmin.vue?vue&type=template&id=9b2a461e&scoped=true"
import script from "./OrderDetailAdmin.vue?vue&type=script&lang=js"
export * from "./OrderDetailAdmin.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailAdmin.vue?vue&type=style&index=0&id=9b2a461e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2a461e",
  null
  
)

export default component.exports